<!--
 * @Author: xiaokun
 * @Date: 2020-04-11 16:38:12
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-11 18:14:36
 * @Description: 导入问题左侧树形组件
 -->
<template>
  <mk-tree
    ref="tree"
    :data="treeData"
    node-key="_id"
    :default-expanded-keys="defaultExpandedKeys"
    class="common-tree"
    @node-click="onNodeClick"
    @node-expand="onNodeExpand"
    @node-collapse="onNodeCollapse"
  >
    <template v-slot="{node,data}">
      <span class="menu-name">
        <span class="menu-name-text">
          <ds-iconfont icon-class="icon-ds-wenjianjia"></ds-iconfont>
          <span>{{ data.label }}</span>
        </span>
      </span>
    </template>
  </mk-tree>
</template>

<script>
export default {
  name: 'CommonTree',
  props: {
  },
  data () {
    return {
      // tree data
      treeData: [],
      defaultExpandedKeys: [],
      treeVersion: 0,
      // 是否正在加载
      isLoading: false
    }
  },
  computed: {
    // 当前menu的版本
    version () {
      return this.treeData[0].version
    }
  },
  created () {
    this.getTreeData()
  },
  methods: {
    // 获得tree数据
    async getTreeData () {
      this.isLoading = true
      let res = await CONVERSATIONAPIS.QuestionsApi.pQuestionTreeGet()
      if (res.success) {
        this.treeData = [res.data]
        // 默认展开一级节点
        this.defaultExpandedKeys.push(this.treeData[0]._id)
        this.$emit('tree-init', res.data)
      }
      this.isLoading = false
    },

    // 当节点被点击时
    onNodeClick (data) {
      this.$emit('node-click', data)
    },

    // 当节点被展开时候，加入到数组中，更新节点的时候重新渲染tree用于展开
    onNodeExpand ({ _id }) {
      this.defaultExpandedKeys.push(_id)
    },

    // 当节点被收起时候，从数组中移除，更新节点的时候重新渲染tree用于展开
    onNodeCollapse ({ _id }) {
      let index = this.defaultExpandedKeys.indexOf(_id)
      this.defaultExpandedKeys.splice(index, 1)
    }

  }
}
</script>

<style lang="scss" scoped>
.common-tree {
  padding: 10px 0;

  .menu-name {
    font-size: 13px;
    color: #595959;
    display: flex;
    justify-content: space-between;
    width: 100%;

    &:hover {
      .menu-operate {
        display: inline-block;
      }
    }

    .icon-ds-wenjianjia {
      color: rgba(0, 156, 255, 1);
      margin-right: 3px;
    }

    .menu-name-text {
      max-width: 100px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .menu-operate {
      display: none;

      .ds-iconfont {
        color: rgba(0, 156, 255, 1);
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }

  // 以下代码为覆盖tree样式
  /deep/ .el-tree-node__expand-icon {
    color: #595959;
  }

  /deep/ .el-tree-node__expand-icon.is-leaf {
    color: transparent;
  }

  // /deep/ .el-tree-node:focus > .el-tree-node__content

  /deep/ .el-tree-node__content {
    height: 32px;
    line-height: 32px;
    color: #595959;

    &:hover {
      background-color: #dbf1ff;
    }
  }
}
</style>
